module.exports = __webpack_public_path__ + "img/list-pattern2.1e95e4f.svg";